import React from "react";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import { CustomFlag } from "utilities";
import MDBox from "components/Basics/MDBox";
import useGetTranslationLanguage from "helpers/useGetTranslationLanguage";
import UploadFile from "./UploadFile/UploadFile";
import PageWeb from "./PageWeb";
import SiteMap from "./SiteMap";
import EditorHtml from "./HTML";
import {
	HTMLTEXT,
	FILE_TYPE_DOCUMENT,
	FILE_TYPE_SITEMAP,
	FILE_TYPE_WEB_PAGE
} from "../../../../../contants";

const LanguageInput = ({
	languageName = "",
	language,
	typology,
	onChangeTypologyInput,
	codeLanguage,
	value,
	isEdit,
	disabled,
	onFileUploaded,
	url,
	codeLanguagePosibles,
	acceptedFile
}) => {
	const handleChangeTypology = (field, valueChange) => {
		onChangeTypologyInput(codeLanguage, field, valueChange);
	};
	const translationLanguage = useGetTranslationLanguage();

	return (
		<MDBox>
			<Stack direction={{ xs: "column", sm: "row" }} spacing={{ xs: 1, sm: 1, md: 1 }}>
				<CustomFlag
					code={codeLanguage}
					style={{
						heigth: "2vh",
						width: "2vh"
					}}
				/>
				<Typography variant="body2" sx={{ mb: 1 }}>
					{translationLanguage(languageName)}
				</Typography>
			</Stack>
			<Box sx={{ marginTop: 1 }}>
				{typology === FILE_TYPE_DOCUMENT && (
					<UploadFile
						codeLanguage={codeLanguage}
						onChangeTypologyInput={onChangeTypologyInput}
						isEdit={isEdit}
						existingFile={value}
						attachments={value?.attachments}
						disabled={disabled}
						onFileUploaded={onFileUploaded}
						acceptedFile={acceptedFile}
					/>
				)}

				{typology === FILE_TYPE_WEB_PAGE && (
					<PageWeb handleChange={handleChangeTypology} value={value} disabled={disabled} />
				)}
				{typology === FILE_TYPE_SITEMAP && (
					<SiteMap handleChange={handleChangeTypology} value={value} disabled={disabled} />
				)}
				{typology === HTMLTEXT && (
					<EditorHtml
						codeLanguage={codeLanguage}
						value={value?.[HTMLTEXT]}
						handleChange={handleChangeTypology}
						disabled={disabled}
						codeLanguagePosibles={codeLanguagePosibles}
					/>
				)}
			</Box>
		</MDBox>
	);
};

export default LanguageInput;
